import React, { FC } from "react";
import Pagination from "shared/Pagination/Pagination";

interface Column {
  key: string;
  label: string;
  render?: (item: any) => React.ReactNode;
}

interface DynamicTableProps {
  columns: Column[];
  data: any[];
  onNext?: () => void;
  onPrev?: () => void;
  className?: string;
}

const DynamicTable: FC<DynamicTableProps> = ({ columns, data, onNext, onPrev, className = "" }) => {
  return (
    <div className={`overflow-hidden bg-white rounded-lg shadow-lg dark:bg-gray-800 ${className}`}>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm text-gray-700 dark:text-gray-300">
          <thead className="text-xs tracking-wide text-gray-600 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-200">
            <tr>
              {columns?.map((column) => (
                <th
                  key={column.key}
                  scope="col"
                  className={`px-6 py-4 ${column.key === "actions" ? "text-center" : "text-left"}`}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => (
              <tr
                key={index}
                className="transition-colors border-b border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
              >
                {columns?.map((column) => (
                  <td
                    key={column.key}
                    className={`px-6 py-4 ${column.key === "actions" ? "text-center" : "text-left"} ${
                      column.key !== "actions" ? "font-medium" : ""
                    }`}
                  >
                    {column.render ? column.render(item) : item[column.key] || "-"}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex items-center justify-between px-6 py-4 bg-gray-50 dark:bg-gray-800">
        <span className="inline-flex items-center px-3 py-1 text-sm font-medium text-blue-700 bg-blue-100 rounded-full dark:bg-blue-900 dark:text-blue-200">
          {data.length} éléments
        </span>
        {(onNext || onPrev) && (
          <div className="flex space-x-2">
            <button
              onClick={onPrev}
              disabled={!onPrev}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-200 disabled:opacity-50"
            >
              Précédent
            </button>
            <button
              onClick={onNext}
              disabled={!onNext}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-full dark:bg-gray-700 dark:text-gray-200 disabled:opacity-50"
            >
              Suivant
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DynamicTable;
